import { render, staticRenderFns } from "./account-balance.component.vue?vue&type=template&id=b9aea82c&"
import script from "./account-balance.component.vue?vue&type=script&lang=ts&"
export * from "./account-balance.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports